import {Component} from 'react';
import {loadModules} from 'esri-loader';

export default class Sketch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sketch: null
        };
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules(['esri/widgets/Sketch', 'esri/widgets/Sketch/SketchViewModel']).then(([Sketch, SketchViewModel]) => {

            const sketchViewModel = new SketchViewModel({
                layer: this.props.map.findLayerById(this.props.layerId),
                view: this.props.view,
            });

            let sketch = new Sketch({
                layer: this.props.map.findLayerById(this.props.layerId),
                view: this.props.view,
                viewModel: sketchViewModel
            });

            this.setState({sketch});
            this.props.view.ui.add(sketch, 'bottom-right');
        }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.view.ui.remove(this.state.sketch);
    }
}
